import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getPncByCode = (code = ' ') => apiActionCreator({
  'endpoint': `/part-number-code/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PNC_INSTANCE_INFO_REQUEST,
    ActionTypes.GET_PNC_INSTANCE_INFO_SUCCESS,
    [
      ActionTypes.GET_PNC_INSTANCE_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
